// extracted by mini-css-extract-plugin
module.exports = {"title":"CryptoWallets_title__19P6I"};